module.exports = __webpack_public_path__ + "images/c64be094936f03380eee86963dc4c754-IMG_9379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_9379.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_9379.jpg
// module chunks = 0